module.exports = __webpack_public_path__ + "img/service_icon1.81b7eb1d.png";